import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SocialAuthService } from 'angularx-social-login';
import { NewFooterComponent } from './new-footer/new-footer.component';
import { TopBarComponent } from '../top-bar/top-bar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { PipeModule } from '../pages/pipe.module'
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { LoginModal } from '../header/header.component'
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input'
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { TooltipModule } from 'ng2-tooltip-directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BlockScrollStrategy, Overlay } from '@angular/cdk/overlay';
import { CountdownModule } from 'ngx-countdown';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ConfirmationComponent } from '../confirmation/confirmation.component';
import { MyJsonLdComponent } from './my-json-ld.component';


export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
    return () => overlay.scrollStrategies.block();
}
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatMenuModule,
        PipeModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatCardModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatSnackBarModule,
        MatSelectModule,
        TooltipModule,
        MatTooltipModule,
        NgOptimizedImage,
        CountdownModule,
        MatAutocompleteModule,
        NgxSpinnerModule
    ],

    declarations: [
        LoginModal,
        NewFooterComponent,
        TopBarComponent,
        ConfirmationComponent,
        MyJsonLdComponent,

    ],

    exports: [
        LoginModal,
        NewFooterComponent,
        TopBarComponent,
        ConfirmationComponent,
        MyJsonLdComponent,

        PipeModule,
    ],
    providers: [
        SocialAuthService,
        DatePipe,
        {
            provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
            useFactory: scrollFactory,
            deps: [Overlay],
        },
    ]

})
export class CommonChildComponentsModule { }
